module.exports = __webpack_public_path__ + "img/background.71345ed0.png";